module.exports = __webpack_public_path__ + "img/ddm2.a5d801cc.png";